type FormattedCountry = {
  img: string;
  name: string;
};

type Props = {
  country: FormattedCountry | undefined;
};

export const FormattedCountryCell = ({ country }: Props) => {
  if (!country) return null;

  const { name, img } = country;

  return (
    <div>
      <img src={img} alt={`${name} flag`} />
      {` ${name}`}
    </div>
  );
};

export default FormattedCountryCell;
